import { render, staticRenderFns } from "./OtherReciveForm.vue?vue&type=template&id=7b01167b&scoped=true"
import script from "./OtherReciveForm.vue?vue&type=script&lang=js"
export * from "./OtherReciveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b01167b",
  null
  
)

export default component.exports